module.exports = __webpack_public_path__ + "img/bookshelf22.5c95286c.jpg";